import React from 'react'

/**
 * 行展开图标
 */
export const ExpandIcon = (): JSX.Element => (
  <svg width="16px" height="9px" viewBox="0 0 16 9" fill="currentColor">
    <g transform="translate(-1496.000000, -893.000000)">
      <polygon transform="translate(1504.065864, 897.424621) rotate(-270.000000) translate(-1504.065864, -897.424621) " points="1506.71751 897.424621 1500 890.707107 1500.70711 890 1508.13173 897.424621 1500.70711 904.849242 1500 904.142136"></polygon>
    </g>
  </svg>
)
